import type { RouteRecordRaw } from 'vue-router'

const cashierRoutes: RouteRecordRaw = {
  path: '/cashier',
  name: 'Cashier',
  redirect: '/cashier/journal',
  meta: { title: '出纳管理', icon: 'icon-money' },
  children: [
    {
      path: 'journal',
      name: 'CashJournal',
      component: () => import('@/views/cashier/CashJournal.vue'),
      meta: { title: '现金银行日记账', permissions: ['cashier:journal:view'] },
    },
    {
      path: 'bank',
      name: 'BankReconciliation',
      component: () => import('@/views/cashier/BankReconciliation.vue'),
      meta: { title: '银行对账', permissions: ['cashier:bank:view'] },
    },
    {
      path: 'cashcount',
      name: 'CashCount',
      component: () => import('@/views/cashier/CashCount.vue'),
      meta: { title: '现金盘点', permissions: ['cashier:cashcount:view'] },
    },
    {
      path: 'balance',
      name: 'CashBalance',
      component: () => import('@/views/cashier/CashBalance.vue'),
      meta: { title: '资金余额表', permissions: ['cashier:balance:view'] },
    },
  ],
}

export default cashierRoutes
